import React from 'react';
import RestSelect from './RestSelect';
import { trainingProgramCRUD } from '../../http/CRUD';

const TrainingProgramSelect = (props) => {
    return (
        <RestSelect
            restApi={trainingProgramCRUD}
            optionValueKey="id"
            optionLabelKey="name"
            getOptionLabel={(option) => option.code ? `${option.code} - ${option.name}` : option.name}
            {...props}
        />
    );
};

export default TrainingProgramSelect;
